import _ from 'lodash';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Alert, Button } from 'react-bootstrap';
import PairTerminalForm from './PairTerminalForm';
import ContentContainer from '../ContentContainer';

const PairTerminalPage = () => {
  const branch = useSelector((state: any) => state.app.branch);

  if (!_.get(branch, 'payment.resellerName')) {
    return (
      <ContentContainer>
        <Alert variant="warning">
          <Alert.Heading>Missing Configuration</Alert.Heading>
          <p>
            You need to setup a <b>Reseller Name</b> for location <b>{branch.name}</b>.
            <hr />
            <Link to={`/db/UST2/${branch.id}/edit`}>
              <Button variant="secondary">Configure</Button>
            </Link>
          </p>
        </Alert>
      </ContentContainer>
    );
  }

  const handleSubmit = () => {};

  return (
    <ContentContainer>
      <PairTerminalForm onSubmit={handleSubmit} />
    </ContentContainer>
  );
};

export default PairTerminalPage;
